import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { OrTabs } from "../shared_modules/ui/components/atoms/or-tabs/or-tabs";
import { CompanyRegister } from "./CompanyRegister";
import { EmployeeRegister } from "./EmployeeRegister";
import { AuthShell } from "./auth-shell";

import "./auth-ui.css";
import { SocialRegister } from "../social-auth/social-register";
import { useSocialMode } from "../social-auth/social-mode-context";

const registerOptions = [
  { id: "1", label: "Trabajador" },
  { id: "2", label: "Empresa" },
];

export function Register() {
  const [value, setValue] = useState(registerOptions[0]);
  const [searchParams, setSearchParams] = useSearchParams();
  const { isSocialMode } = useSocialMode();

  useEffect(() => {
    if (searchParams.get("s") && searchParams.get("s") === "company") {
      setValue(registerOptions[1]);
    }
  }, [searchParams]);

  if (isSocialMode) {
    return <SocialRegister />;
  }

  const setRegisterType = (nextValue) => {
    const newQueryParameters = new URLSearchParams();

    if (nextValue.id === "2") {
      newQueryParameters.set("s", "company");
    }

    setSearchParams(newQueryParameters);
    setValue(nextValue);
  };

  return (
    <AuthShell
      alignContent="start"
      wide
      title="Crear una cuenta"
      subtitle=""
      footer={
        <>
          <p className="or-auth-form__hint">
            ¿Ya tienes cuenta? <Link to="/login">Inicia sesión</Link>
          </p>
          <a href="https://openreferences.com/aviso-legal/" target="_blank" rel="noreferrer">
            Términos y Condiciones
          </a>
        </>
      }
    >
      <OrTabs
        ariaLabel="Tipo de registro"
        getOptionKey={(option) => option.id}
        getOptionLabel={(option) => option.label}
        onChange={setRegisterType}
        options={registerOptions}
        value={value}
      />

      {value.id === "1" ? <EmployeeRegister /> : <CompanyRegister />}
    </AuthShell>
  );
}
